import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box, CircularProgress } from "@material-ui/core";
import { Image } from "@components/atoms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faHandPointLeft, faCompass } from "@fortawesome/free-regular-svg-icons";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    textAlign: "center",
    margin: 10,
  },
  featureCheck: {
    marginRight: theme.spacing(1),
  },
  iconContainer: {
    width: 80,
    marginBottom: 20,
    marginLeft: "auto",
    marginRight: "auto",
  },
  iconColor: {
    color: "#58a15f",
  },
  pointerIconColor: {
    color: theme.palette.icon.gray,
  },
}));

/**
 * Component to display the job card
 *
 * @param {Object} props
 */
const EmptyStateHolder = (props) => {
  const { placeholderText, icon, displaySelectIcon, locationIcon, className, isLoading, ...rest } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.iconContainer}>
        {!icon && !displaySelectIcon && !locationIcon && !isLoading && (
          <FontAwesomeIcon
            icon={faCheckCircle}
            size="4x"
            className={classes.iconColor}
          />
        )}
        {icon && !isLoading && (
          <Image className={classes.logoImage} src={icon} lazy={false} />
        )}
        {displaySelectIcon && !isLoading && (
          <FontAwesomeIcon
            icon={faHandPointLeft}
            size="8x"
            className={classes.pointerIconColor}
          />
        )}
        {locationIcon && !isLoading && (
          <FontAwesomeIcon
            icon={faCompass}
            size="4x"
            className={classes.iconColor}
          />
        )}
      </div>

      {isLoading && (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      )}

      <Typography variant="4">
        <Box variant="title" fontWeight="fontWeightBold" m={1}>
          {placeholderText}
        </Box>
      </Typography>
    </div>
  );
};

EmptyStateHolder.propTypes = {
  /**
   *  External classes
   */
  className: PropTypes.string,
  /**
   * Text to display
   */
  placeholderText: PropTypes.string.isRequired,
  /**
   * optional Icon
   */
  icon: PropTypes.string,
};

export default EmptyStateHolder;
